export default "__VITE_ASSET__CJDgSExT__";